import React from 'react';
import omit from 'lodash/omit';
import { useRouter } from 'next/router';
import uri from 'urijs';
import { createPropsForProduct } from 'Components/utils/product/product.utils';
import { t } from 'Src/i18n';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import { Button } from 'Components/frameworks/button/Button';
import { Product } from 'Components/widgets/product/Product';
type Props = {
  categoryGA?: string;
  className?: string;
  onClick?: (id: string, name: string) => unknown;
  scrollToBookingEngineEntryPoint?: () => void;
  suggestion: ResortSuggestion;
};
export const AlternativeResortThumbnail = ({
  categoryGA = 'resort',
  className,
  onClick,
  scrollToBookingEngineEntryPoint,
  suggestion,
}: Props) => {
  const router = useRouter();
  const trackClick = useTracking({
    actionGA: 'checkPricesKO',
    categoryGA,
  });

  const handleClick = () => {
    const { id, name, href } = suggestion.resort;
    const url = `${href}?${uri.buildQuery(omit(router.query, ['dynamicPage']))}`;
    onClick
      ? onClick(id, name)
      : router.push(url).then(() => {
          if (scrollToBookingEngineEntryPoint) {
            scrollToBookingEngineEntryPoint();
          }
        });
  };

  return (
    <div className={className} data-testid="AlternativeResortThumbnail">
      <Product
        {...createPropsForProduct(suggestion.resort)}
        hasLazyLoading={false} // Allows to avoid to launch the tracking on the arrows of the slider
        onClick={(e) => {
          if (e.target instanceof HTMLImageElement) {
            handleClick();
            trackClick({
              labelGA: 'resort_checkThumbnail',
            });
          }
        }}
      />
      <Button
        className="mt-20 w-full"
        data-testid="AlernativeResortThumbnailButton"
        onClick={() => {
          handleClick();
          trackClick({
            actionGA: 'checkPricesKO',
            categoryGA: 'resort',
            labelGA: 'resort_check',
          });
        }}
      >
        {t('booking.counterProposalPopIn.checkPriceLabelResort')}
      </Button>
    </div>
  );
};
